// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"f7","text":"f8","subText":"f9","toggleContainer":"f-","checked":"f_"};